import { FREELANCECLIENTPRIMARY } from "../../ENVIRONMENT";

// api for freelance primary list
function freeprimaryList(token) {
  const response = fetch(FREELANCECLIENTPRIMARY, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freeprimaryList };
